module.exports = __webpack_public_path__ + "img/slotmachine_normal.80c9652a.png";